export const NONCONSIGNMENT_CERTIFICATE_TYPE = "Nonconsignment"

export const FilterChipLabels: { [key: string]: string } = {
  status_label: "Status",
  organisation: "Consignor",
  country_name: "Country Name",
  transport_mode: "Transport Mode",
  departure_ts: "Departure Date",
  approved_at: "Approval Date",
  submitted_at: "Submitted Date",
  third_party_consignor: "3rd Party Access only",
  inspection_port: "Inspection Port",
  discharge_port: "Port of Discharge",
  certificate_type: "Non consignment requests",
}
